import React, { Component } from 'react';
import Sidebar from '../navigation/Sidebar';
import Content from './Content';
import Rest from "../../services/Rest";
const initialState = {
    error: false,
    message: "",
    datadashboard: {
        saldo: 0,
        campañas: [],
        m_enviados: 0,
        m_recibidos: 0,
        total: 0,
        servidores: []
    }
}
class Dashboard extends Component {

    constructor(props) {
        super(props)
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...initialState }


    componentWillMount() {
        if (typeof this.datauser === "undefined") {
            localStorage.removeItem("ls");
            window.location = window.location.origin;
        }
    }


    componentDidMount() {

        this.Rest.get('usuarios/dashboard', this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        datadashboard: {
                            saldo: response.data.saldo,
                            campañas: response.data.campañas,
                            m_enviados: response.data.m_enviados,
                            m_recibidos: response.data.m_recibidos,
                            total: response.data.total_campañas || 0,
                            servidores: response.data.servidores
                        }
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            message: response.data
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    message: "Error de respuesta del servidor"
                })
            })

    }

    render() {
        return (
            <div className="wrapper">
                <Sidebar logout={() => this.props.callBackLogout()} />
                <Content dashboard={this.state.datadashboard} />
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js